import React, { useState, useContext, useEffect } from "react";
import { CircularProgress } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

import { getSession, updateSession } from "../api/MeAPI"
import { logout } from "../api/AuthAPI"
import ExternApp from "./ExternApp";
import InternApp from "./InternApp";
import { AppContext } from "./AppContext";

const useStyles = makeStyles(theme => ({
    box: {
        display: "flex",
        justifyContent: "center",
    },
    progress: {
        margin: theme.spacing(4),
    },
}));

export default function SessionHolder() {
    const context = useContext(AppContext);
    const classes = useStyles();
    const [status, setStatus] = useState<"unknown" | "out" | "in" | "switching">("unknown");
    const [completed, setCompleted] = useState<number>(0);
    const [error, setError] = useState<string>();

    context.removeSession = () => {
        setStatus("switching");
        logout().then(() => {
            setStatus("out");
            context.setSession(undefined);
        }).catch((error) => {
            setError(error.message);
            setStatus("in");
        });
    };

    context.onSignedIn = () => {
        setCompleted(new Date().getTime());
    };

    context.onChangedTenant = (tenantId: string, customerId?: string) => {
        setStatus("switching");
        updateSession(tenantId, customerId).then((session) => {
            window.location.href = "/";
        }).catch((error) => {
            setError(error.message);
            setStatus("in");
        });
    };

    useEffect(() => {
        getSession().then(session => {
            context.setSession(session);
            setStatus("in");
        }).catch((_) => {
            context.setSession(undefined);
            setStatus("out");
        });
        // eslint-disable-next-line
    }, [completed]);

    if (status === "unknown") {
        return (
            <div className={classes.box}>
                <CircularProgress className={classes.progress} />
            </div>
        );
    } else if (status === "out") {
        return <ExternApp />;
    }

    return <InternApp backdrop={status === "switching"} error={error} onCleanError={() => setError(undefined)} />;
}